/**
 * 孕期主题集群 Tab 切换
 * 用途: Section3 分段 Tab —— 点击/键盘切换面板；H5 下把选中 Tab 滚到可视区左边缘（左右双向）
 * 依赖: 无（原生 JS，IIFE 隔离）
 * 标记: [data-bp-cluster]
 */
;(function () {
  'use strict'

  var MOBILE_QUERY = '(max-width: 768px)'

  /**
   * 把选中 Tab 的左边缘对齐标签栏可视区左边缘（仅 H5，左右双向）
   * - Tab 在可视区右侧 → 向右滚
   * - Tab 在可视区左侧（已滚出）→ 向左滚
   * - 滚到尽头时按可滚范围钳制，不会越界
   * @param {HTMLElement} tablist - 滚动容器
   * @param {HTMLElement} tab - 选中的 tab
   */
  function scrollTabIntoLeft(tablist, tab) {
    if (!tablist || !tab) return
    if (!window.matchMedia(MOBILE_QUERY).matches) return

    let box = tablist.getBoundingClientRect()
    let rect = tab.getBoundingClientRect()
    let cs = window.getComputedStyle(tablist)
    // 可视区左边缘 = 左边框 + 左内边距（否则会被 padding 顶开）
    let padLeft = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.borderLeftWidth) || 0)
    let delta = rect.left - (box.left + padLeft)
    if (Math.abs(delta) < 1) return

    // 钳制到可滚范围：0 ~ (内容宽 - 可视宽)
    let maxLeft = Math.max(0, tablist.scrollWidth - tablist.clientWidth)
    let target = Math.min(Math.max(0, tablist.scrollLeft + delta), maxLeft)
    if (Math.abs(target - tablist.scrollLeft) < 1) return

    let reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    tablist.scrollTo({
      left: target,
      behavior: reduce ? 'auto' : 'smooth',
    })
  }

  function init(root) {
    let tablist = root.querySelector('.blog-pillar-theme-cluster__tabs')
    if (!tablist) return
    let tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'))
    if (!tabs.length) return
    let panels = tabs.map(function (tab) {
      var id = tab.getAttribute('aria-controls')
      return id ? root.querySelector('#' + id) : null
    })

    /**
     * 激活指定索引的 tab 与面板
     * @param {number} index - 目标索引
     * @param {boolean} focus - 是否把焦点移到 tab
     */
    function activate(index, focus) {
      tabs.forEach(function (tab, i) {
        let on = i === index
        tab.setAttribute('aria-selected', on ? 'true' : 'false')
        tab.setAttribute('tabindex', on ? '0' : '-1')
        if (panels[i]) panels[i].hidden = !on
      })
      if (focus && tabs[index]) tabs[index].focus()
      scrollTabIntoLeft(tablist, tabs[index])
    }

    let current = tabs.findIndex(function (t) {
      return t.getAttribute('aria-selected') === 'true'
    })
    if (current < 0) current = 0

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        current = i
        activate(i, false)
      })
    })

    tablist.addEventListener('keydown', function (e) {
      let next = null
      if (e.key === 'ArrowRight') next = (current + 1) % tabs.length
      else if (e.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length
      else if (e.key === 'Home') next = 0
      else if (e.key === 'End') next = tabs.length - 1
      if (next === null) return
      e.preventDefault()
      current = next
      activate(next, true)
    })
  }

  function boot() {
    let roots = document.querySelectorAll('[data-bp-cluster]')
    Array.prototype.forEach.call(roots, init)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }
})()
